import type { FeatureFlag } from '@gozoki/api-types'
import { queryOptions } from '@tanstack/react-query'

import { gozokiApiWithAuth } from '../gozokiApi'
import { keys } from './keys'

export const fetchFeatureFlags = async (): Promise<FeatureFlag[]> => {
  const response = await gozokiApiWithAuth.get<FeatureFlag[]>('/feature-flags')
  return response.data
}

export const getFeatureFlagsQueryOptions = () =>
  queryOptions({
    queryKey: keys.featureFlags.list(),
    queryFn: fetchFeatureFlags,
  })
